import { AccountTree, Analytics, Apartment, Engineering, Group, Home, Interests, LineAxis, Place, Report } from "@mui/icons-material"

const superAdminRoutes = [
    {
        type: "route",
        name: "Dashboard",
        key: ['/admin'],
        route: "/admin",
        icon: <Home size="12px" color="warning" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Perencanaan",
        key: ['/admin/perencanaan', '/admin/perencanaan/detail', '/admin/perencanaan/rincian-belanja'],
        route: "/admin/perencanaan",
        icon: <Analytics size="12px" color="info" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Struktur Anggaran",
        key: ['/admin/struktur-anggaran'],
        route: "/admin/struktur-anggaran",
        icon: <AccountTree size="12px" color="success" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "Laporan",
        key: ['/admin/laporan', '/admin/laporan/detail', '/admin/laporan/rincian-belanja', '/admin/laporan/komponen'],
        route: "/admin/laporan",
        icon: <Report size="12px" color="secondary" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "PDN & TKDN",
        key: ['/admin/pdn'],
        route: "/admin/pdn",
        icon: <LineAxis size="12px" color="primary" />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Paket Pekerjaan",
        key: ['belanja', 'belanja-modal', 'projek-strategis', 'paket-dak'],
        icon: <Engineering size="12px" color="error" />,
        collapse: [
            {
                name: "Komponen Belanja",
                key: ['/admin/belanja', '/admin/belanja/komponen'],
                route: "/admin/belanja",
            },
            {
                name: "Belanja Modal",
                key: ['/admin/belanja-modal', '/admin/belanja-modal/komponen'],
                route: "/admin/belanja-modal",
            },
            {
                name: "Projek Strategis",
                key: ['/admin/projek-strategis', '/admin/projek-strategis/komponen'],
                route: "/admin/projek-strategis",
            },
            {
                name: "DAK",
                key: ['/admin/paket-dak', '/admin/paket-dak/komponen'],
                route: "/admin/paket-dak",
            },
        ],
    },
    {
        type: "route",
        name: "Lokasi Pekerjaan",
        key: ['/admin/lokasi-pekerjaan'],
        route: "/admin/lokasi-pekerjaan",
        icon: <Place size="12px" color="success" />,
        noCollapse: true,
    },
    // {
    //     type: "route",
    //     name: "Map AI",
    //     key: ['/admin/map-ai'],
    //     route: "/admin/map-ai",
    //     icon: <Place size="12px" color="success" />,
    //     noCollapse: true,
    // },
    { type: "divider", title: "Account Pages", key: "settings-divider" },
    { type: "title", title: "Settings", key: "settings" },
    // {
    //     type: "route",
    //     name: "Daftar OPD",
    //     key: ['/admin/opd'],
    //     route: "/admin/opd",
    //     icon: <Apartment size="12px" color="primary" />,
    //     noCollapse: true,
    // },
    // {
    //     type: "route",
    //     name: "Anggaran OPD",
    //     key: ['/admin/anggaran-opd'],
    //     route: "/admin/anggaran-opd",
    //     icon: <AttachMoney size="12px" color="secondary" />,
    //     noCollapse: true,
    // },
    {
        type: "collapse",
        name: "OPD",
        key: ['opd', 'anggaran-opd', 'opd/detail'],
        icon: <Apartment size="12px" color="primary" />,
        collapse: [
            {
                name: "Daftar OPD",
                key: ['/admin/opd', '/admin/opd/detail'],
                route: "/admin/opd",
            },
            {
                name: "Anggaran OPD",
                key: ['/admin/anggaran-opd'],
                route: "/admin/anggaran-opd",
            },
        ],
    },
    {
        type: "collapse",
        name: "Users",
        key: ['admin-opd', 'admin'],
        icon: <Group size="12px" color="error" />,
        collapse: [
            {
                name: "Admin",
                key: ['/admin/admin'],
                route: "/admin/admin",
            },
            {
                name: "OPD",
                key: ['/admin/admin-opd'],
                route: "/admin/admin-opd",
            },
        ],
    },
    {
        type: "collapse",
        name: "Kodefikasi",
        key: ['kodefikasi-perencanaan', 'kodefikasi-rekening', 'sumber-pendanaan'],
        icon: <Interests size="12px" color="success" />,
        collapse: [
            {
                name: "Kodefikasi Perencanaan",
                key: ['/admin/kodefikasi-perencanaan'],
                route: "/admin/kodefikasi-perencanaan",
            },
            {
                name: "Kodefikasi Rekening",
                key: ['/admin/kodefikasi-rekening'],
                route: "/admin/kodefikasi-rekening",
            },
            {
                name: "Sumber Pendanaan",
                key: ['/admin/sumber-pendanaan'],
                route: "/admin/sumber-pendanaan",
            },
        ],
    },
    // {
    //     type: "route",
    //     name: "Numenklatur & TA",
    //     key: ['/admin/numenklatur-ta'],
    //     route: "/admin/numenklatur-ta",
    //     icon: <PersonAdd size="12px" color="info" />,
    //     noCollapse: true,
    // },
]

export default superAdminRoutes